module.exports = __webpack_public_path__ + "static/media/BarlowSemiCondensed-Black.67737fd0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/BarlowSemiCondensed-Black.ttf
// module id = 2897
// module chunks = 51